import React from "react";
import { Formik, Form, Field } from "formik";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Switch,
  Tooltip,
  FormControlLabel,
} from "@mui/material";
import { TextField } from "formik-mui";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import PropTypes from "prop-types";

import { addTab, editTab } from "../../../../store/ducks/duckTab";
import { useUser } from "../../../../auth/UserProvider";
import { BorderLinearProgress } from "../../../../components/LoadingComponent";

const TabForm = (props) => {
  const { initialValues, isEdit, handleClose, open } = props;
  const { isAdmin } = useUser();
  const { enqueueSnackbar } = useSnackbar();

  const dispatch = useDispatch();

  return (
    <>
      <Formik
        initialValues={initialValues}
        validate={(values) => {
          let errors = {};

          if (!values.label) {
            errors.name = "Required";
          }

          return errors;
        }}
        onSubmit={(values, { setSubmitting }) => {
          let { label, id } = values;

          return values.id > 0
            ? dispatch(editTab(values, id)).then(() => {
                handleClose();
                setSubmitting(false);
                enqueueSnackbar(`Edited '${label}' Tab Successfully`, {
                  variant: "success",
                });
              })
            : dispatch(addTab(values)).then(() => {
                handleClose();
                setSubmitting(false);
                enqueueSnackbar(`Added '${label}' Tab Successfully`, {
                  variant: "success",
                });
              });
        }}
      >
        {({ submitForm, isSubmitting, values, setFieldValue }) => (
          <Form>
            <Dialog
              fullWidth
              aria-labelledby="form-dialog-title"
              maxWidth="xs"
              open={open}
              onClose={handleClose}
            >
              {isSubmitting && <BorderLinearProgress />}
              <DialogTitle id="form-dialog-title">
                {isEdit && initialValues.id !== 0
                  ? "Edit"
                  : !isEdit && initialValues.id !== 0
                    ? "Details"
                    : "Add"}
                {initialValues.deleted && isAdmin && values.id !== 0 && (
                  <>
                    <Tooltip
                      key={`Helper-deleted-admin-tooltip`}
                      title={values.deleted ? "Enable" : "Disable"}
                    >
                      <FormControlLabel
                        control={
                          <Switch
                            checked={values.deleted}
                            name="deleted"
                            onChange={() => setFieldValue("deleted", !values.deleted)}
                          />
                        }
                        label="Deleted"
                        style={{ marginRight: 0, marginLeft: "60%" }}
                      />
                    </Tooltip>
                  </>
                )}
              </DialogTitle>
              <DialogContent style={{ overflow: "hidden" }}>
                <Grid container spacing={4} styles={{ margin: "auto" }}>
                  <Grid item xs={6}>
                    <Field
                      component={TextField}
                      disabled={values.deleted}
                      label="Label"
                      margin="dense"
                      name="label"
                      type="text"
                      variant="outlined"
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <Field
                      fullWidth
                      component={TextField}
                      disabled={values.deleted}
                      label="Value"
                      margin="dense"
                      name="value"
                      type="number"
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button color="primary" variant="contained" onClick={handleClose}>
                  Close
                </Button>
                {isEdit && (
                  <Button color="primary" variant="contained" onClick={submitForm}>
                    Save
                  </Button>
                )}
              </DialogActions>
            </Dialog>
          </Form>
        )}
      </Formik>
    </>
  );
};

TabForm.propTypes = {
  initialValues: PropTypes.object,
  isEdit: PropTypes.bool,
  handleClose: PropTypes.bool,
  open: PropTypes.bool.isRequired,
};
export default TabForm;
